<template lang="html">
  <sl-sp-page :data="info"></sl-sp-page>
</template>
<script>
export default {
  data() {
    return {
      info: {
        title: this.$t('Views.401.title'),
        cnt1: this.$t('Views.401.cnt1'),
        cnt2: this.$t('Views.401.cnt2'),
        btn1: this.$t('Views.401.btn1'),
        btn2: this.$t('Views.401.btn2'),
        showBtn1: false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// 401.vue?beebd7b0